import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import { UserIcon, NotificationTrayIcon } from '../../../../common/icons';
import { Dropdown, Icon, Menu } from 'antd';

import './HeaderNotificationArea.css';

@withRouter
@inject('translationsStore', 'authStore', 'commonStore', 'noticesStore')
@observer
export default class HeaderNotificationArea extends Component {
  showNotices = () => {
    const { noticesStore } = this.props;
    noticesStore.carouselVisible = true;
  };

  render() {
    const { commonStore, noticesStore, translationsStore, authStore, location } = this.props;
    const styleBullet = noticesStore.carsHaving.length === 0 ? { visibility: 'hidden' } : {};

    let profileData = commonStore.dealer;

    if (authStore.isServiceManager) {
      profileData = commonStore.profile;
    }
    const dealerMenuItems = [
      { title: translationsStore.translate('header.menu.labelConnectionRequest'), to: '/connection-requests' },
      { title: translationsStore.translate('header.menu.labelSubscriptionManager'), to: '/subscription-manager' },
      { title: translationsStore.translate('header.menu.labelVehiclesManager'), to: '/vehicles-manager' },
      ...(commonStore.dealer && commonStore.dealer.masterApiUserUuid && commonStore.dealer.myfleetPermissionDriver ?
      [{ title: translationsStore.translate('header.menu.labelDriversManager'), to: '/drivers-manager' }
    ]
    : []),
      { title: translationsStore.translate('header.menu.labelPaymentManagement'), to: '/payment-management' }
    ]

    const menuItems = [
      ...(!authStore.isServiceManager && commonStore.dealer && commonStore.dealer.masterApiUserUuid ? dealerMenuItems : []),
      { title: translationsStore.translate('header.menu.labelProfile'), to: '/profile' },
      { title: translationsStore.translate('header.menu.labelSupport'), to: '/support' },
      {
        title: (
          <div style={{ display: 'inline-flex' }}>
            <Icon type="poweroff" width="15px" height="14px" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
            <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('logout')}</span>
          </div>
        ),
        to: '/logout'
      }
    ];

    const menu = (
      <Menu>
        {menuItems.map((item, index) => {
          const active = location.pathname.indexOf(item.to) === 0;
          const style = active
            ? {
                color: '#007e7c',
                fontWeight: 'bold',
                borderLeft: '4px solid rgb(0, 126, 124)',
                marginLeft: 0,
                paddingLeft: 8
              }
            : {
                paddingLeft: 12
              };
          return (
            <Menu.Item key={index}>
              <Link to={item.to}>
                <span style={style}>{item.title}</span>
              </Link>
            </Menu.Item>
          );
        })}
      </Menu>
    );

    return (
      <div className="HeaderNotificationArea">
        {(!authStore.isServiceManager &&
          <NotificationTrayIcon className="NotificationTray" onClick={this.showNotices} style={{ width: '16px', height: '20px' }} />
        )}
        {(!authStore.isServiceManager &&
          <div className="NotificationBullet" style={styleBullet}>
            •
          </div>
        )}
        <Dropdown overlay={menu}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="NotificationProfileName">{(profileData || {}).companyName}</div>
            <div className="icon-cnt">
              <div className="user-icon-bg" />
              <UserIcon style={{ color: 'var(--primary-color)', position: 'relative', zIndex: '10' }} />
            </div>
          </div>
        </Dropdown>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderNotificationArea/HeaderNotificationArea.js